import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidCategoriseYesNo } from '../../../../../mechanics/rid-categorise-yes-no/rid-categorise-yes-no';

@Component({
  selector: 'app-yes-no-sentence-page',
  imports: [RidCategoriseYesNo],
  templateUrl: './yes-no-sentence-page.html',
})
export class YesNoSentencePage {
  protected readonly $router = inject(Router);
}
